<template>
  <section class="banner__area banner__area-d pb-10 ad-banner-section ad-banner-section--interactive">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12" v-if="activeAdsByType[4]">
          <div class="ad-banner-3d">
            <AdBannerMouse3d>
              <div class="ad-banner-3d__inner">
                <div
                  class="banner__item p-relative w-img mb-30 ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                  :key="adKey(activeAdsByType[4], 4)"
                >
                  <div class="banner__img ad-banner__media">
                    <a
                      v-if="linkIsExt(activeAdsByType[4])"
                      :href="linkExtHref(activeAdsByType[4])"
                      class="d-block h-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[4].image_url"
                        :alt="adPlainTitle(activeAdsByType[4].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                    <router-link
                      v-else
                      :to="linkPath(activeAdsByType[4])"
                      class="d-block h-100"
                    >
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[4].image_url"
                        :alt="adPlainTitle(activeAdsByType[4].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </router-link>
                  </div>
                  <div class="banner__content ad-banner__content--hero">
                    <span>{{ activeAdsByType[4].tag }}</span>
                    <h6>
                      <a
                        v-if="linkIsExt(activeAdsByType[4])"
                        :href="linkExtHref(activeAdsByType[4])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[4].title"
                        ></span>
                      </a>
                      <router-link v-else :to="linkPath(activeAdsByType[4])">
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[4].title"
                        ></span>
                      </router-link>
                    </h6>
                    <p v-if="activeAdsByType[4].text">{{ activeAdsByType[4].text }}</p>
                  </div>
                </div>
              </div>
            </AdBannerMouse3d>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12" v-if="activeAdsByType[5]">
          <div class="ad-banner-3d">
            <AdBannerMouse3d>
              <div class="ad-banner-3d__inner">
                <div
                  class="banner__item p-relative w-img mb-30 ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                  :key="adKey(activeAdsByType[5], 5)"
                >
                  <div class="banner__img ad-banner__media">
                    <a
                      v-if="linkIsExt(activeAdsByType[5])"
                      :href="linkExtHref(activeAdsByType[5])"
                      class="d-block h-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[5].image_url"
                        :alt="adPlainTitle(activeAdsByType[5].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                    <router-link v-else :to="linkPath(activeAdsByType[5])" class="d-block h-100">
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[5].image_url"
                        :alt="adPlainTitle(activeAdsByType[5].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </router-link>
                  </div>
                  <div class="banner__content ad-banner__content--hero">
                    <span>{{ activeAdsByType[5].tag }}</span>
                    <h6>
                      <a
                        v-if="linkIsExt(activeAdsByType[5])"
                        :href="linkExtHref(activeAdsByType[5])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[5].title"
                        ></span>
                      </a>
                      <router-link v-else :to="linkPath(activeAdsByType[5])">
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[5].title"
                        ></span>
                      </router-link>
                    </h6>
                    <p v-if="activeAdsByType[5].text">{{ activeAdsByType[5].text }}</p>
                  </div>
                </div>
              </div>
            </AdBannerMouse3d>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AdBannerMouse3d from './AdBannerMouse3d.vue';
import {
  adIsExternal as linkIsExt,
  adRouterPath as linkPath,
  adExternalHref as linkExtHref,
} from '@/utils/ad-media';

export default {
  components: { AdBannerMouse3d },
  props: {
    ads: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    bannerTypes45() {
      return [4, 5]
    },
    adsByType() {
      const groupedAds = {}
      this.ads.forEach((ad) => {
        const t = Number(ad.add_type)
        if ([4, 5].includes(t)) {
          if (!groupedAds[t]) groupedAds[t] = []
          groupedAds[t].push(ad)
        }
      })
      return groupedAds
    },
    activeAdsByType() {
      const result = {}
      this.bannerTypes45.forEach((t) => {
        const list = this.adsByType[t] || []
        if (!list.length) return
        const i = Number.isFinite(this.activeIndexByType[t])
          ? this.activeIndexByType[t]
          : 0
        result[t] = list[i] || list[0]
      })
      return result
    },
  },
  data() {
    return {
      activeIndexByType: {},
      rotationMs: 3000,
      rotationIntervalId: null,
    }
  },
  watch: {
    ads: {
      immediate: true,
      deep: true,
      handler() {
        this.syncActiveIndexes()
        this.restartRotation()
      },
    },
  },
  mounted() {
    this.syncActiveIndexes()
    this.restartRotation()
  },
  beforeUnmount() {
    if (this.rotationIntervalId) clearInterval(this.rotationIntervalId)
  },
  methods: {
    linkIsExt,
    linkPath,
    linkExtHref,
    syncActiveIndexes() {
      this.bannerTypes45.forEach((t) => {
        const list = this.adsByType[t] || []
        if (!list.length) {
          delete this.activeIndexByType[t]
          return
        }
        const current = Number(this.activeIndexByType[t] || 0)
        this.activeIndexByType[t] = current >= list.length ? 0 : current
      })
    },
    restartRotation() {
      if (this.rotationIntervalId) clearInterval(this.rotationIntervalId)
      const hasMultipleAds = this.bannerTypes45.some(
        (t) => (this.adsByType[t] || []).length > 1
      )
      if (!hasMultipleAds) {
        this.rotationIntervalId = null
        return
      }
      this.rotationIntervalId = setInterval(() => {
        this.bannerTypes45.forEach((t) => {
          const list = this.adsByType[t] || []
          if (list.length > 1) {
            const i = Number(this.activeIndexByType[t] || 0)
            this.activeIndexByType[t] = (i + 1) % list.length
          }
        })
      }, this.rotationMs)
    },
    adKey(ad, type) {
      const id = ad?.id ?? ad?.ad_id ?? ad?.advertisement_id ?? ad?.image_url ?? 'ad';
      const idx = Number(this.activeIndexByType[type] || 0);
      return `${type}-${idx}-${id}`;
    },
    adPlainTitle(html) {
      if (!html || typeof html !== 'string') return '';
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
  },
};
</script>

<style scoped>
/* 3D: _ad-banner-3d.scss */
.ad-rotate-swap {
  animation: ad-rotate-swap 0.55s ease both;
}

@keyframes ad-rotate-swap {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>